module.exports = __webpack_public_path__ + "img/cm_s2-desc.a185cc2d.png";